export default __webpack_public_path__ + "static/media/correspondent3.454e0e97.png";